import { Toolbar, IconButton, Typography, Chip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
// import Avatar from '@mui/material/Avatar';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FaceIcon from '@mui/icons-material/Face';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';

import { AuthContext } from '../auth/authContext';

export const Header = ({ open, toggleDrawer }) => {

  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const handleClick = () => {
    navigate('/profile')
  }

  return (
    <AppBar position="absolute" open={open}>
      <Toolbar
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: '36px',
            ...(open && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="subtitle1"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        >
          SIGIA ANIBER
        </Typography>
        <Chip variant='filled' sx={{ cursor: 'pointer' }} icon={<FaceIcon />} deleteIcon={<ArrowDropDownIcon />} onDelete={handleClick} onClick={handleClick} color='info' label={user.email.split('@')[0]} />
        {/* <Avatar sx={{cursor:'pointer'}} onClick={handleClick} alt="Remy Sharp" src="/static/images/avatar/1.jpg" >{user.email.substring(0,2)} </Avatar> */}

      </Toolbar>
    </AppBar>
  )
}

const drawerWidth = 250;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));